module.exports = __webpack_public_path__ + "img/raketa_doleva.d62d9948.png";